var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('MainBanner'),_c('NextAuction'),_c('UpcomingAuctions'),_c('ArtistsCarrousel',{attrs:{"artists":_vm.artistsData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }